if (!customElements.get('product-media')) {
  customElements.define(
    'product-media',
    class ProductMedia extends HTMLElement {
      constructor() {
        super();

        this.swiper = null;
        this.swiperElement = this.querySelector('.swiper');

        if (window.innerWidth < 600) {
          this.initMobileSwiper();
        } else {
          $('product-media img').ezPlus({
              zoomType: 'inner',
              cursor: 'zoom-in'
          });
        }

        document.querySelectorAll(".product-media-videos").forEach(videoEl => {
            const myInterval = setInterval(autoplayVideo, 100);
        	function autoplayVideo() {
                if(videoEl.paused){
                    videoEl.play();
                    clearInterval(myInterval);
                }else clearInterval(myInterval);
            }
        })
      }

      initMobileSwiper() {
        if (!this.swiperElement) return;

        this.swiper?.destroy(true, false);
        this.swiper = new Swiper(this.swiperElement, {
          loop: false,
          autoHeight: true,
          autoplay: { delay: 5000, disableOnInteraction: false },
          slidesPerView: 1,
          watchOverflow: true,
          observer: true,
          observeParents: true,
        });
        this.swiper.slideTo(this.getFirstVisibleSlideIndex(), 0, false);
        this.swiper.updateAutoHeight(0);
      }

      refreshMobileSwiper() {
        if (window.innerWidth >= 600 || !this.swiperElement) return;
        this.initMobileSwiper();
      }

      getFirstVisibleSlideIndex() {
        const slides = Array.from(this.querySelectorAll('.swiper-slide'));
        const index = slides.findIndex((slide) => window.getComputedStyle(slide).display !== 'none');

        return index > -1 ? index : 0;
      }
    }
  )
}


